// MainTableList.js

import React, { useState } from "react";
import styles from "./MainTableList.module.css";
import SubTableList from "./SubTableList";

import { FiChevronDown, FiChevronRight } from "react-icons/fi";

import { Spinner } from "react-bootstrap";

const MainTableList = ({  
  data,
  loading,  
  handle_SubProducts,
}) => {
  const [openRow, setOpenRow] = useState(null);

  const tableData = data;

  // OPEN / CLOSE
  const handleToggle = (id,productName) => {
    setOpenRow(openRow === id ? null : id);
    handle_SubProducts(id,productName);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        {/* HEADER */}
        {/* <div className={styles.header}>
<h3>{title}</h3>
</div> */}

        {/* MAIN TABLE */}
        <div className={styles.tableScroll}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.arrowCol}></th>

                <th>Sub Product Name</th>
              </tr>
            </thead>

            <tbody>
              {/* LOADING */}
              {loading ? (
                <tr>
                  <td colSpan={2} className={styles.loadingTd}>
                    <div className={styles.loadingWrapper}>
                      <Spinner animation="border" variant="primary" size="sm" />

                      <span>Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {tableData?.map((item) => {
                    const isOpen = openRow === item.id;

                    return (
                      <React.Fragment key={item.id}>
                        <tr
                          key={`row_${item.id}`}
                          className={`${styles.row} ${
                            isOpen ? styles.activeRow : ""
                          }`}
                          onClick={() => handleToggle(item.id,item?.mpname)}
                        >
                          {/* ARROW */}
                          <td className={styles.arrowTd}>
                            <div
                              className={`${styles.arrowIcon} ${
                                isOpen ? styles.rotateArrow : ""
                              }`}
                            >
                              {isOpen ? (
                                <FiChevronDown size={16} />
                              ) : (
                                <FiChevronRight size={16} />
                              )}
                            </div>
                          </td>

                          {/* SUB PRODUCT NAME */}
                          <td>{item?.mpname || "-"}</td>
                        </tr>

                        {/* SUB TABLE */}
                        {isOpen && (
                          <tr>
                            <td colSpan={2} className={styles.subTableWrapper}>
                              {/* <SubTableList
                                data={subProductList || []}
                                mainId={item?.id}
                                setNewSubData={setNewSubData}
                                subLoading={subLoading}
                              /> */}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}

                  {/* EMPTY */}
                  {tableData?.length === 0 && (
                    <tr>
                      <td colSpan={2} className={styles.empty}>
                        No Data Found
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MainTableList;
